exports["UA"] = require("./UA.js");
exports["GR"] = require("./GR.js");
exports["CS"] = require("./CS.js");
exports["DE"] = require("./DE.js");